import React from "react";
import { AuditCta } from "@/components/AuditCta";

export const ClosingCta = ({
  headline = "Find out where your leads are slipping.",
  body = "30 minutes, free, and a one-page summary within 48 hours.",
  testId = "closing-cta",
}) => (
  <section className="bg-[#3D472D] px-6 sm:px-8 py-20 sm:py-28" data-testid={testId}>
    <div className="max-w-3xl mx-auto text-center">
      <h2 className="font-fraunces font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F4E9D8] leading-tight">
        {headline}
      </h2>
      <p className="mt-6 text-base md:text-lg text-[#F4E9D8]/70 leading-relaxed">{body}</p>
      <div className="mt-10 flex justify-center">
        <AuditCta variant="onDark" testId={`${testId}-button`} />
      </div>
    </div>
  </section>
);

export default ClosingCta;
